/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef } from 'react';
// import 'xgplayer/dist/index.min.css';
import videoPlayerStore from "@/store/videoPlayer.store";
import Hls from 'hls.js';
import summaryCommonStore from '@/store/summaryCommon.store';

interface VideoPlayerProps {
  videoUrl: string;
  onLoadCb: () => void;
  onWaitCb: (waiting: boolean) => void;
  onErrorCb: () => void;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoUrl, onLoadCb, onWaitCb, onErrorCb }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    videoPlayerStore.getState().setPlayer(videoRef.current);
    if (!video) return;

    const handlePlay = () => {
      console.log('play');
    };

    const handlePause = () => {
      console.log('pause');
    };

    const handleError = (e: any) => {
      console.log('video error', e);
      video.pause();
      onErrorCb();
    };

    const handleLoadedData = (e: any) => {
      console.log('loadeddata', e);
      console.log('onDuration', video.duration)
      videoPlayerStore.getState().setTotalTime(video.duration);
      onLoadCb();
    };

    const handleMyEnded = (e: any) => {
      console.log('ended', e);
      handleEnded();
    };

    const handleTimeUpdate = () => {
      videoPlayerStore.getState().onProgress({ playedSeconds: video.currentTime });
      if (video.duration !== videoPlayerStore.getState().totalDuration) {
        console.log('handleTimeUpdate set total time', video.duration);
        videoPlayerStore.getState().setTotalTime(video.duration);
      }
    };
    const handleWaiting = (e: any) => {
      console.log('waiting', e);
      onWaitCb(true);
    };

    const handleCanPlay = (e: any) => {
      console.log('canplay', e);
      onWaitCb(false);
      videoPlayerStore.getState().checkPlayStatus();
    };

    video.addEventListener('play', handlePlay);
    video.addEventListener('pause', handlePause);
    video.addEventListener('error', handleError);
    video.addEventListener('loadedmetadata', handleLoadedData);
    video.addEventListener('ended', handleMyEnded);
    video.addEventListener('timeupdate', handleTimeUpdate);
    video.addEventListener('waiting', handleWaiting);
    video.addEventListener('canplay', handleCanPlay);

    const handleHlsError = async (_event: any, data: any) => {
      if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {
        if (data.response && data.response.code === 403) {
          console.log("403 Forbidden error while loading video source");
          // 记住当前播放时间和播放状态,重新请求url
          videoPlayerStore.getState().setVideoLoaded(false);
          const videoRef = videoPlayerStore.getState().videoRef;
          const oldTime = videoRef?.currentTime;
          const isPlaying = videoPlayerStore.getState().isPlaying;
          await summaryCommonStore.getState().refreshMediaInfo();
          // 重新设置到播放位置
          videoPlayerStore.getState().setVideoLoaded(true);
          console.log("oldPlayingTime", oldTime, isPlaying);
          videoPlayerStore.getState().changeSchedule(oldTime || 0, true);
          if (isPlaying) {
            videoPlayerStore.getState().play();
          }
        }
      }
    };

    if (Hls.isSupported()) {
      const hls = new Hls({ enableWorker: true, lowLatencyMode: true, backBufferLength: 90 });
      hls.on(Hls.Events.ERROR, handleHlsError);
      hls.loadSource(videoUrl);
      hls.attachMedia(video);
      console.log('hls loaded')
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = videoUrl;
      onLoadCb();
      console.log('video origin loaded')
    } else {
      console.error('This browser does not support HLS.');
    }

    return () => {
      video.removeEventListener('play', handlePlay);
      video.removeEventListener('pause', handlePause);
      video.removeEventListener('error', handleError);
      video.removeEventListener('loadeddata', handleLoadedData);
      video.removeEventListener('timeupdate', handleTimeUpdate);
      video.removeEventListener('ended', handleMyEnded);
      video.removeEventListener('waiting', handleWaiting);
      video.removeEventListener('canplay', handleCanPlay);
      videoPlayerStore.getState().setPlayer(null);
    };
  }, [videoUrl]);

  const handleEnded = () => {
    console.log('onEnded');
    videoPlayerStore.getState().endPlay();
  }

  return (
    <div className='w-full h-full' >
      <video
        ref={videoRef}
        width="100%"
        height="100%"
        playsInline
      />
    </div>
  );
};

export default VideoPlayer;